/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { ILabelStyles } from '@fluentui/react/lib/Label';
import { IStackItemStyles, IStackStyles } from '@fluentui/react/lib/Stack';
import { FontWeights, ITheme } from '@fluentui/react/lib/Styling';

import { FontSizes } from '../../../styles/teams';

export const getPageStyles = (): Partial<IStackStyles> => {
    return { root: { height: '100%', padding: '1.7rem 2rem 2.3rem 2rem' } };
};

export const getTitleStyles = (theme: ITheme): Partial<ILabelStyles> => {
    return {
        root: {
            color: theme.palette.black,
            fontSize: FontSizes.size18,
            fontWeight: FontWeights.bold,
            height: '1.25rem',
            lineHeight: '1.25rem',
            padding: 0,
            marginBottom: '2.5rem',
        },
    };
};

export const getBodyStyles = (): Partial<IStackItemStyles> => {
    return { root: { height: '100%', overflowX: 'hidden', overflowY: 'auto' } };
};

export const getFooterStyles = (): Partial<IStackItemStyles> => {
    return {
        root: {
            flexDirection: 'row-reverse',
            selectors: {
                button: {
                    marginLeft: '0.75rem',
                },
            },
        },
    };
};
